import { Initializer } from 'common/types/initializers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

export const AppointmentDetailsInitializer = (props: any): Initializer => {
  const node = getOrAppendChild({ id: 'calendar-drawer-container', parentNode: document.body });
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="AppointmentDetails"
        props={{
          ...props,
        }}
      />,
      node,
    );
  };

  return { destroy, render };
};
